import PropTypes from 'prop-types'

const FieldInput = ({
                        id,
                        type,
                        placeholder,
                        iconBefore,
                        iconAfter,
                        wrapperClasses,
                        inputClasses,
                        field,
                        max,
                        disabled,
                        form: {touched, errors}
                    }) => {
    return (
        <div className={"mb-5" + wrapperClasses}>
            <div className="field input-group flex py-2 mb-2 shadow">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                   {iconBefore}
                </span>
                }
                <input
                    value={field.value}
                    id={id}
                    type={type}
                    disabled={!!disabled}
                    max={max}
                    className={`w-full  py-2 px-3 text-gray-700 leading-tight focus:outline-none bg-white focus:shadow-outline` + inputClasses}
                    placeholder={placeholder}
                    {...field}
                />
                {iconAfter &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                    {iconAfter}
                </span>
                }
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldInput

FieldInput.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    max: PropTypes.string,
    disabled: PropTypes.bool,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
}

